import { FC } from 'react'

import { Button } from 'components/atoms/Button'

import { ProcessBadge } from '../ProcessBadge'
import { EmailAlertGroupPrefill, NotConfiguredRow } from '../processCatalogue'

export interface EmailAlertNotConfiguredCardProps {
  row: NotConfiguredRow
  showPartnerLabel: boolean
  canEdit: boolean
  onSetUpClick: (prefill: EmailAlertGroupPrefill) => void
}

/** BDL20-4262: a silent alert — the code sends this ServiceName for the partner but no group exists. */
export const EmailAlertNotConfiguredCard: FC<
  EmailAlertNotConfiguredCardProps
> = ({
  row,
  showPartnerLabel,
  canEdit,
  onSetUpClick,
}: EmailAlertNotConfiguredCardProps) => {
  return (
    <div className='border-[1.5px] border-dashed border-N-300 bg-N-50 rounded-md px-5 py-[18px] flex flex-col gap-3'>
      <div className='flex items-start gap-3.5 flex-wrap'>
        <div className='flex-1 min-w-[280px] flex flex-col gap-[5px]'>
          <div className='flex items-center gap-2.5 flex-wrap'>
            <span className='text-[15.5px] font-bold text-N-600'>
              {row.entry.displayName}
            </span>
            <ProcessBadge label={row.entry.defaultTag} />
            {showPartnerLabel && (
              <span className='text-[11px] font-semibold text-N-500 bg-N-100 rounded px-2 py-[2px]'>
                {row.partner.name} ({row.partner.code})
              </span>
            )}
            <span className='text-[11px] font-semibold text-N-500 border border-N-300 rounded px-2 py-[2px]'>
              Not configured
            </span>
          </div>
          <span
            className='text-[12px] text-N-500 font-mono'
            title='Service name'>
            {row.entry.serviceName}
          </span>
        </div>
        <div className='flex items-center gap-3 flex-wrap'>
          <span className='text-[13px] text-N-500'>
            Not configured — emails for this process are not sent.
          </span>
          {canEdit && (
            <Button
              appearance='outline'
              size='sm'
              onClick={() =>
                onSetUpClick({
                  partnerId: row.partner.id,
                  partnerName: row.partner.name,
                  partnerCode: row.partner.code,
                  process: row.entry.process,
                  outcome: row.entry.outcome,
                })
              }>
              <i className='ri-add-line pr-[7px]'></i>
              Set up
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default EmailAlertNotConfiguredCard
